class FetchError extends Error {
  constructor(message) {
    super(message);
    this.name = "FetchError";
    
    Object.setPrototypeOf(this, FetchError.prototype);
  }
}

export default FetchError;
